export default "__VITE_ASSET__DspjJ4wg__"